import store from "@/state/store";


// TODO: Apply getModuleAccess to all modules
// awaiting list of modules

/**
 * Will show toast that contains values send by the user.
 *
 * @param categoryName  Category of the module
 * @param moduleName Specific name of the module
 * @param submoduleName Specific name of the submodule
 * @returns Module access of the user.
 */
export async function getModuleAccess(categoryName, moduleName, submoduleName = "") {
  let fetchedModules = await store.dispatch("user/getUserAccess");
  
  let access = {
    create: false,
    read: false,
    update: false,
    delete: false,
  };
  
  if (fetchedModules != undefined) {
    let modules = JSON.parse(fetchedModules);
    let category = modules.find((item) => item.name == categoryName);
    let module = category.modules.find((item) => item.name == moduleName);

    if (submoduleName != "") {
      access = module.submodules.find(
        (item) => item.name == submoduleName
      ).access;
    } else {
      access = module.access;
    }
  }
  return access;
}

export async function checkIfDisabled(categoryName = "", moduleName = "") {
  try {
    let fetchedModules = JSON.parse(localStorage.getItem('userAccess'))
    let disabled = true;
    let modules = JSON.parse(fetchedModules);
    let category = await handleUndefinedModule(modules.find((item) => item.name == categoryName));
    let module = await handleUndefinedModule(category.modules.find((item) => item.name == moduleName));

    if (moduleName != "") {
      disabled = module.enabled ? false : true;
    } else {
      console.log('category name: ', categoryName)
      console.log('category: ', category)
      
      disabled = category.enabled ? false : true;

      console.log('disabled: ', disabled)
    }

    return disabled;
  } catch (error) {
    console.log(error)
    return true;
  }
  
}

async function handleUndefinedModule(statement) {
  try {
      return statement != undefined ? statement : { enabled: false }   
  } catch (error) {
      return { enabled: false }
  }
}